import ApiService from '@/services/core/api.service'

const SDashboard = {
  async get (query = '') {
    return ApiService.get(`merchant/dashboard?${query}`)
  }
}

export default SDashboard
